export enum GuideClickType {
  Guide = 'GuideClickType_Guide',
  Facebook = 'GuideClickType_Facebook',
  Instagram = 'GuideClickType_Instagram',
  Twitter = 'GuideClickType_Twitter',
  Website = 'GuideClickType_Website',
}
